import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Button from '@material-ui/core/Button'

// Shared components
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import { api_host } from '../../common/globals/constants';
import { AtCircularProgress } from '../../components/AtCircularProgress';
import { Card, CardContent } from '@material-ui/core';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
class Screenshot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            range: {},
            dateRange: {
                selection: {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',                    
                },
            },
            tokenPicture: this.props.data.tokenPicture,
            service: this.props.data.service,
            currentObjectiveId: this.props.data.currentObjectiveId,
            isLoading: true,
            image: null,
            stepName: this.props.data.nameStep,
            dateBeginScreenshot: this.props.data.dateBeginScreenshot,
            isEmpty: false, 
            pattern: this.props.data.pattern
        }
    }
    componentDidMount() {
        this.getDataFromAPI();
    } 
    getDataFromAPI = (objectiveId) => {
        
        const {currentObjectiveId, service, tokenPicture } = this.state
        let token = sessionStorage.getItem('key')
        
        fetch (api_host+`/reporte/general/objetivos/${currentObjectiveId}/screenshots/image/?token=${token}&img_token=${tokenPicture}&thumbnail=f&service=${service}&form=jpeg&base64=t`)        
            .then( response => response.json())
            .then( myJson =>  {              
                                try {
                                    this.processData(myJson)   
                                            
                                } catch (error) {
                                    this.setState({
                                        dataError: true,
                                        data: null,
                                        isLoading: false
                                    });
                                }
                            });
        
    }
    processData = (externalData) => {
     
        const byteCharacters = atob(externalData[0].img_token);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        let image = new Blob([byteArray], { type: 'image/jpeg' });
        let imageUrl = URL.createObjectURL(image);
        var isEmpty = false
        if (image.size == 0){
            isEmpty = true
        }
        this.setState({image: imageUrl, isLoading: false, isEmpty: isEmpty});
        
    }

    handleClose = event => {
        this.props.onClose()
    };
    
    render() {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        const {isLoading, image, stepName, dateBeginScreenshot, isEmpty, pattern} = this.state
        if (!isLoading)  {
            return  <Card>
                        <PortletHeader style={{backgroundColor:'#0b1738', color:'white'}}>
                                    <PortletLabel 
                                        variant="h6"
                                        title={stepName+' - '+dateBeginScreenshot}                                        
                                    />
                                    <PortletToolbar>
                                        {isEmpty ?
                                            null
                                        :
                                            <Button href={image}
                                                target="_blank"
                                                download={stepName+' - '+dateBeginScreenshot}>
                                                <CloudDownloadIcon style={{color:"white"}}  />
                                            </Button>
                                        }
                                        <IconButton 
                                            key="close" 
                                            aria-label="close" 
                                            style={{color:"white"}}
                                            onClick={this.handleClose}>
                                                <CloseIcon/>
                                        </IconButton>
                                    </PortletToolbar>
                        </PortletHeader >
                            <PortletHeader style={{backgroundColor:'#0b1738', color:'white'}}>
                                <PortletLabel 
                                        variant="h6"
                                        title={t('text.pattern') + ': ' + pattern}                                        
                                    />
                            </PortletHeader>
                            <CardContent style={{backgroundColor: 'white',
                                                    textAlign: 'center',
                                                    position: 'relative',
                                                    overflow: 'auto'
                                                }}>
                                {isEmpty ?
                                    <Typography                                        
                                        variant="h3">                                     
                                        {t('screenshot.modal.no-image')}
                                    </Typography> 
                                :<img src={image} style={{height: '100%', maxHeight: 500, width: '100%'}} height='500px' />}    
                                
                            </CardContent>
                    </Card>
                                
            
        } else {
            return  <Card>
                        <CardContent>
                            <AtCircularProgress />
                        </CardContent>
                    </Card>        
        }
    }
}
export default compose(withTranslation())(Screenshot);